export default __webpack_public_path__ + "static/blob-37-f2b93e10f5cd3987c60115865eb5a149.svg";